"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    root: {
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    flagWrapper: function flagWrapper(_ref2) {
      var width = _ref2.width,
        height = _ref2.height;
      return {
        position: 'relative',
        width: width,
        height: height,
        boxSizing: 'content-box'
      };
    },
    grey: {
      opacity: 0.3
    },
    flag: function flag(_ref3) {
      var width = _ref3.width,
        height = _ref3.height;
      return {
        width: width,
        height: height,
        objectFit: 'cover',
        borderRadius: '14%',
        marginBottom: '1px',
        display: 'block'
      };
    },
    codeLabel: {
      fontSize: '11px',
      fontFamily: typography.fontFamilySecondary,
      fontWeight: typography.fontWeightSemiBold,
      lineHeight: '15px',
      margin: '4px 0 0 0'
    }
  };
}, {
  name: 'Flag'
});
exports.useStyles = useStyles;